<div class="view-request-base">
  <div *ngIf="loading" class="loading">
    {{ loadingText }}
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div *ngIf="!loading && !error && request" class="request-details-compact">
    <!-- Компактная основная информация -->
    <div class="info-card">
      <div class="info-header">
        <h3>{{ requestNumberText }} {{ request.id | docNo:'R':request.createdAt }}</h3>
        <span class="rate-badge">{{ getRateTypeName(request.rateType) }}</span>
      </div>
      
      <div class="info-grid">
        <div class="info-row">
          <span class="info-label">{{ routeText }}:</span>
          <span class="info-value route-compact">
            {{ getCountryName(request.fromCountryId) }} ({{ request.fromCity }}) 
            <span class="arrow">→</span> 
            {{ getCountryName(request.toCountryId) }} ({{ request.toCity }})
          </span>
        </div>
        
        <div class="info-row">
          <span class="info-label">{{ loadingDateText }}:</span>
          <span class="info-value">{{ formatDate(request.loadingDate) }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">{{ priceText }}:</span>
          <span class="info-value price-highlight">
            {{ request.price | number:'1.2-2' }} {{ getCurrencySymbol(request.currencyId) }}
          </span>
        </div>
        
        <div class="info-row" *ngIf="request.createdAt">
          <span class="info-label">{{ createdAtText }}:</span>
          <span class="info-value">{{ formatDate(request.createdAt) }}</span>
        </div>
      </div>
    </div>

    <!-- Компактные продукты -->
    <div class="info-card products-compact">
      <div class="products-header">
        <h3>{{ productsText }}</h3>
        <div class="totals-inline">
          <span class="total-badge">
            <strong>{{ totalWeightTotalText }}:</strong> {{ formatWeight(getTotalWeight()) }}
          </span>
          <span class="total-badge">
            <strong>{{ totalVolumeTotalText }}:</strong> {{ formatTotalVolume(getTotalVolume()) }}
          </span>
        </div>
      </div>
      
      <div class="products-table">
        <div *ngFor="let product of request.products; let i = index" class="product-row-compact">
          <div class="product-number">#{{ i + 1 }}</div>
          <div class="product-info-grid">
            <div class="product-field">
              <span class="field-label">{{ cargoTypeText }}:</span>
              <span class="field-value">{{ getCargoTypeName(product.cargoTypeId) }}</span>
            </div>
            <div class="product-field" *ngIf="product.tnvedCode">
              <span class="field-label">{{ tnvedCodeText }}:</span>
              <span class="field-value">{{ product.tnvedCode }}</span>
            </div>
            <div class="product-field" *ngIf="product.name">
              <span class="field-label">{{ nameText }}:</span>
              <span class="field-value">{{ product.name }}</span>
            </div>
            <div class="product-field">
              <span class="field-label">{{ quantityText }}:</span>
              <span class="field-value">{{ product.quantity || 1 }}</span>
            </div>
            <div class="product-field">
              <span class="field-label">{{ totalWeightText }}:</span>
              <span class="field-value">{{ formatWeight(product.totalWeightKg) }}</span>
            </div>
            <div class="product-field" *ngIf="product.lengthMm && product.widthMm && product.heightMm">
              <span class="field-label">{{ dimensionsText }}:</span>
              <span class="field-value">{{ product.lengthMm }} × {{ product.widthMm }} × {{ product.heightMm }} {{ millimeterUnitText }}</span>
            </div>
            <div class="product-field">
              <span class="field-label">{{ volumeText }}:</span>
              <span class="field-value">{{ formatVolume(product.lengthMm, product.widthMm, product.heightMm, product.volumeM3, product.quantity) }}</span>
            </div>
            <div class="product-field flags-field" *ngIf="product.isDangerous || product.isOversized || product.isNonStackable">
              <span class="flag-compact" *ngIf="product.isDangerous">⚠️ {{ isDangerousText }}</span>
              <span class="flag-compact" *ngIf="product.isOversized">📦 {{ isOversizedText }}</span>
              <span class="flag-compact" *ngIf="product.isNonStackable">📚 {{ isNonStackableText }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
